import { useEffect, useState } from 'react'
import { Box, Typography, Button, Radio, FormControlLabel } from '@mui/material'
import { useAtom } from 'jotai'
import { useSelector } from 'react-redux'
import { companySettingsAtom, kenyaCountryCodesAtom, makeGetRequest, paybillDetailsAtom } from './jotaiState/commonStateAtoms'
import DropDownOA from './dropDownOA'
import {
  InitiateMpesaPaymentAtom,
  intiateMpesaRes,
  mpesaPaymentStatus,
  newOrUsedAtom,
  pollMpesaPaymentAtom,
  sender_ISD_Code,
  unUtilisedMpesaList,
  unUtilisedMpesaPaymentAtom,
} from './jotaiState/bookingStateAtoms'
import LineinputV2 from './lineinputV2'
import { phonefilter } from './bookingInputHandleChange'
import Timer from './Timer'
import Modal from './modal'
import { urls } from './constants'
import { alertAtom } from './jotaiState/globalStateAtoms'
import { useTranslation } from '../../i18n/I18nProvider'

export const modalStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

export const BookingConfirmMpesa = (props) => {
  const { translations } = useTranslation()
  const cs = translations.common
  const de = translations.delivery
  const { data, updateModal } = props
  const { ttype = 'B' } = data
  const [phone, setPhone] = useState('')
  const { priceSectionData } = data
  const amount = ttype === 'D' ? data?.finalAmt || 0 : priceSectionData?.gross_amount || 0
  const [kenyaISDCodes] = useAtom(kenyaCountryCodesAtom)
  const [sendISDCode] = useAtom(sender_ISD_Code)
  const [payISDCode, setPayISDCode] = useState(sendISDCode)
  const [companySettings] = useAtom(companySettingsAtom)
  const [paybillDetails] = useAtom(paybillDetailsAtom)
  const [timerCount, setTimerCount] = useState(0)
  const [disableButton, setDisableButton] = useState(false)
  const [buttonType, setButtonType] = useState(0)
  const { BusinessShortCode = '' } = { ...paybillDetails }
  const [newOrUtil, setNewOrUtils] = useAtom(newOrUsedAtom)
  const [paymentStatus] = useAtom(mpesaPaymentStatus)
  const [mpesaPaymentInfo, setMpesaPaymentInfo] = useAtom(intiateMpesaRes)
  const [, initiatePayment] = useAtom(InitiateMpesaPaymentAtom)
  const [, pollMpesaPayment] = useAtom(pollMpesaPaymentAtom)
  const [, unUtilisedMpesaPayment] = useAtom(unUtilisedMpesaPaymentAtom)
  const [unUtilisedPaymentList,setunUtilisedPaymentList] = useAtom(unUtilisedMpesaList)
  const loginData = useSelector((state) => state?.common?.loginData)
  const { intCompanyID, intBranchID, intUserID } = { ...loginData }
  const MobileNoULimit = 9
  const [selectUtil, setSelectUntil] = useState({})
  const [, setAlert] = useAtom(alertAtom)
  useEffect(() => {
    setPayISDCode(sendISDCode)
  }, [sendISDCode])
  useEffect(() => {
    if (data.sendMobNo) setPhone(data.sendMobNo)
  }, [data])
  useEffect(() => {
    if (unUtilisedPaymentList.length && newOrUtil === 2) {
      setSelectUntil(unUtilisedPaymentList[0])
      setDisableButton(false)
    }
  }, [unUtilisedPaymentList, newOrUtil])
  const handleTimerExpire = () => {
    setDisableButton(false)
    setTimerCount((a) => (a < 2 ? a + 1 : -1))
  }
  const mpesapoller = (mpesaPaymentInfo, PGUsed = 'SO') => {
    const apiData = {
      CompanyId: intCompanyID,
      UserIDBooked: intUserID,
      intOrderID: mpesaPaymentInfo?.OrderId,
      strCheckoutRequestID: mpesaPaymentInfo?.CheckoutRequestID,
      PGUsed: PGUsed,
      PaymentSubType: 'Mpesa',
      dcmlWalletProcessingCharge: 0,
      intBranchID: intBranchID,
    }
    makeGetRequest(urls.confirmValidateMpesaPayment + '?', apiData).then((res) => {
      if (res.status === 'Success' && res?.Data?.Table?.[0]?.Orderid) {
        data?.yesAction && data.yesAction({ WalletOrderId: res.Data.Table[0].Orderid })
      } else if (buttonType === -1 && newOrUtil === 1) {
        setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
      }
    })
  }
  useEffect(() => {
    if (Object.keys(mpesaPaymentInfo).length && disableButton) {
      let elapsed = 0
      let interval = 5000
      const maxFastPollTime = 20000
      const pollerRef = { current: null }
      let timeoutRef = null

      const startPolling = () => {
        pollerRef.current = setInterval(() => {
          mpesapoller(mpesaPaymentInfo)
          elapsed += interval

          if (elapsed >= maxFastPollTime && interval === 5000) {
            clearInterval(pollerRef.current)
            interval = 15000
            pollerRef.current = setInterval(() => {
              mpesapoller(mpesaPaymentInfo)
            }, interval)
          }
        }, interval)
      }

      timeoutRef = setTimeout(() => {
        mpesapoller(mpesaPaymentInfo)
        startPolling()
      }, 5000)

      return () => {
        clearInterval(pollerRef.current)
        clearTimeout(timeoutRef)
      }
    }
  }, [mpesaPaymentInfo, disableButton])
  const getLabel = () => {
    if (newOrUtil !== 2) {
      if (buttonType === 2) {
        return de.c2b
      }
      if (buttonType === 1) {
        return de.retry
      }
      if (buttonType === 0) {
        return de.stkPush
      }
    }
    return ttype === 'B' ? de.bookTitle : de.deliverTitle
  }

  const getUnutilisedPayment = () => {
    const data = {
      intCompanyID,
      intBranchID,
      intMode: 1,
      strMobileno: (payISDCode?.name + phone).slice(1),
    }
    unUtilisedMpesaPayment(data)
  }
  const handlesubmit = () => {
      if (newOrUtil !== 2) {
        if (!phone || phone.length !== MobileNoULimit) {
        setAlert({ show: true, msg: de.pleaseEnterValidPhone, nextId: 'payerPhone' })
         return
        }
      const data = {
        CompanyId: intCompanyID,
        intBranchID: intBranchID,
        BookingAmount: amount,
        UserIDBooked: intUserID,
        PgUsed: 'SO',
        strPhone: encodeURIComponent(payISDCode?.name + phone),
        PaymentSubType: 'Mpesa',
        dcmlProcessingCharge: 0,
        TransactionMode: 1,
      }
      if (buttonType === 0 || buttonType === 1) {
        initiatePayment(data)
        setDisableButton(true)
        setButtonType((a) => (a < 2 ? a + 1 : -1))
      } else if (buttonType === 2) {
        const c2bData = { ...data, PgUsed: 'CB' }
        initiatePayment(c2bData)
        setButtonType((a) => (a < 2 ? a + 1 : -1))
      } else if (buttonType === -1) {
        mpesapoller(mpesaPaymentInfo, 'CB')
      }
    } else {
        if (selectUtil?.TotalAmount) {
          if (selectUtil.TotalAmount === amount) {
            mpesapoller(selectUtil, '')
          } else {
          setAlert({
            show: true,
            msg: de.amountMismatchSelectedRequired
              .replace('{{selected}}', selectUtil.TotalAmount)
              .replace('{{required}}', amount),
            nextId: '',
          })
          }
        } else {
          console.log('select payment')
      }
    }
  }
  const handleNewRadio = (type) => {
    if (type === 1) {
      setNewOrUtils(1)
      setSelectUntil({})
      setunUtilisedPaymentList([])
    } else {
      setDisableButton(true)
      setNewOrUtils(2)
    }
  }
  const getAttemptID = (val) => {
    if (!val) return ''
    if (buttonType === 1) {
      return 'STK-' + val
    }
    if (buttonType === 2) {
      return 'Retry-' + val
    }
    if (buttonType === -1) return 'C2B-' + val
  }
  return (
    <Modal
      headTxt={ttype === 'B' ? de.bookWithMPesa : de.deliverWithMPesa}
      width={'400px'}
      updateModal={updateModal}
      closeId={'mpesa-closepopup'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <Box component="div" className="booking-confirmation-wrapper">
        <Typography fontWeight={'bold'} fontSize={'14px'}>
          {de.paymentModeMpesa}
        </Typography>
        <Typography fontWeight={'bold'} fontSize={'14px'}>
         {de.attemptID}:{getAttemptID(mpesaPaymentInfo?.OrderId)}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', height: '60px' }}>
          <Box>
            <img
              src="https://static.cdnlogo.com/logos/m/95/m-pesa.svg"
              alt={de.mpesaLogo}
              width="150"
              height="auto"
              style={{ display: 'block' }}
            />
          </Box>
          <Typography fontSize={'18px'} fontWeight={'600'} color={'#888'}>
           {de.installMpesa}
          </Typography>
        </Box>
        <Box marginBottom={'20px'}>
          <FormControlLabel control={<Radio checked={newOrUtil === 1} onChange={() => handleNewRadio(1)} />} label={de.newPayment} />
          <FormControlLabel control={<Radio checked={newOrUtil === 2} onChange={() => handleNewRadio(2)} />} label={de.unutilisedPayment} />
        </Box>
        <Box display={'flex'}>
          <Box sx={{ width: '115px', display: 'inline-flex', padding: '0% 0px' }}>
            <div className={'input--wrapper'} style={{ width: '100%' }}>
              <DropDownOA
                id={`R_code`}
                label={de.isd}
                defaultvalue={payISDCode?.name || ''}
                data={kenyaISDCodes || []}
                isObjArr={true}
                dataKey={`name`}
                idKey={`id`}
                width="115px"
                searchPlaceholder={de.searchIsdCode}
                onSelect={(val) => setPayISDCode(val)}
              />
            </div>
          </Box>
          <Box sx={{ width: '100%', marginLeft: '10px', display: 'inline-flex', padding: '0% 0px' }}>
            <div className={'input--wrapper'} style={{ width: '100%' }}>
              <LineinputV2
                label={de.mobileNo}
                type="phone"
                name="recMobNo"
                id="payerPhone"
                value={phone}
                filter={(val) => phonefilter(val, MobileNoULimit)}
                maxLength={MobileNoULimit}
                suggestKey="UserDetails"
                suggestSearchKey="MobileNo"
                onBlur={(e) => setPhone(e.target.value || '')}
                handleSuggest={(e, val) => {}}
                onKeyDown={(e) => {}}
              />
            </div>
          </Box>
          {newOrUtil === 2 ? (
            <Button
              variant="contained"
              className="btn add-btn"
              style={{ margin: '0px 0px 0px 5px', height: '40px' }}
              onClick={getUnutilisedPayment}
            >
              {de.go}
            </Button>
          ) : (
            <></>
          )}
        </Box>
        <Box sx={{ width: '100%', display: 'inline-flex', padding: '0% 0px' }}>
          <div className={'input--wrapper'} style={{ width: '100%' }}>
            <LineinputV2
              label={de.amountKes}
              type="phone"
              name="recMobNo"
              value={amount}
              disabled={true}
              suggestKey="UserDetails"
              suggestSearchKey="MobileNo"
              handleSuggest={(e, val) => {}}
              onKeyDown={(e) => {}}
            />
          </div>
        </Box>
        <Box sx={{ width: '100%', display: 'inline-flex', padding: '0% 0px' }}>
          <div className={'input--wrapper'} style={{ width: '100%' }}>
            <LineinputV2
              label={de.payBillNo}
              type="phone"
              name="recMobNo"
              value={BusinessShortCode}
              disabled={true}
              onBlur={(e) => {}}
              handleSuggest={(e, val) => {}}
              onKeyDown={(e) => {}}
            />
          </div>
        </Box>
        <Box sx={{ width: '100%', display: 'inline-flex', padding: '0% 0px' }}>
          <div className={'input--wrapper'} style={{ width: '100%' }}>
            <DropDownOA
              id={`R_code`}
              label={de.businessAccountNoWithDot}
              defaultvalue={newOrUtil === 2 ? selectUtil?.amountorder || '' : mpesaPaymentInfo?.OrderId || 0}
              data={unUtilisedPaymentList}
              isObjArr={true}
              disabled={newOrUtil === 1}
              resetFlag={newOrUtil === 1}
              dataKey={`amountorder`}
              idKey={`OrderId`}
              direction="up"
              onSelect={(val) => setSelectUntil(val)}
              searchPlaceholder={de.businessAccountNo}
            />
          </div>
        </Box>
        {disableButton ? (
          <Box display={'flex'} justifyContent={'center'}>
            <Timer key={timerCount} initialTime={120} onComplete={handleTimerExpire} />
          </Box>
        ) : (
          <></>
        )}
        <Box display={'flex'} justifyContent={'center'} marginBottom={'20px'}>
          <Button className="btn cancel-btn margin-normal" variant="outlined" onClick={() => updateModal(false)}>
            {de.cancelTitle}
          </Button>
          <Button className="btn btn-primary margin-normal" disabled={disableButton} onClick={handlesubmit}>
            {getLabel()}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}
